module.exports = __webpack_public_path__ + "static/media/aavev2.83b5669e.svg";